import { INDEX, THREADS, ON_CHANGE, LOADING } from './types'

const initialState = {
  title: '',
  data: '',
  threads: [],
  filter: '',
  index: null,
  threadLoaded: false,
}

const discussionReducer = (state = initialState, action) => {
  switch (action.type) {
    case INDEX:
      return {
        ...state,
        index: action.index,
      }
    case THREADS:
      return {
        ...state,
        threads: action.threads,
      }
    case ON_CHANGE:
      return {
        ...state,
        [action.property]: action.value,
      }
    case LOADING:
      return {
        ...state,
        [action.loadingType]: action.isLoading,
      }
    default:
      return state
  }
}

export default discussionReducer
